import { usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
import { defineComponent, onBeforeUnmount, watch } from "@vue/composition-api";
import PageTogglerLayout from "../layout/page-toggler-layout.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
import IdentificationInformation from "@Client/@Modules/application-standalone/components/pages/identifications/identification-information.vue";
import IdentificationSummary from "@Client/@Modules/application-standalone/components/pages/identifications/identification-summary.vue";
export default defineComponent({
  name: "IdentificationsPage",
  components: {
    PageTogglerLayout,
    IdentificationInformation,
    IdentificationSummary,
    PageStepLayout
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    useScrollTopOnLoad();
    const {
      handlePageTogglerNavigation,
      showInformationPage,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    } = usePageTogglers();
    watch(showInformationPage, newValue => {
      emit("update:showInformationPage", newValue);
      emit("show-errors", 0);
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      emit("show-errors", 0);
    });
    return {
      showInformationPage,
      handlePageTogglerNavigation,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    };
  }
});